import { render, staticRenderFns } from "./CalcsMenu.vue?vue&type=template&id=3c8db398"
import script from "./CalcsMenu.vue?vue&type=script&lang=js"
export * from "./CalcsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports